import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import StarActiveIcon from '../../../core/icons/images/star-active.svg';
import StarIcon from '../../../core/icons/images/star-unactive.svg';
import {Image} from "../image/image";
import {AppTerms} from "../../app/app-terms";
import {STAR_ICON} from "../star-icon-component/star-icon.consts";
import {EntitySelectionComposer} from "./entity-selection-composer";

export class StarIconComponentProps extends BaseProps {
  i18n: AppTerms;
  isActive: Boolean;
  onClick: Function;
  size: Number = 16;
}

export const StarSelection = EntitySelectionComposer(({
                                                        isActive,
                                                        onClick,
                                                        className,
                                                        size = STAR_ICON.defaultSize,
                                                      }: StarIconComponentProps) => {


  const starProps = {
    className,
    width: size,
    height: size,
    src: isActive ? StarActiveIcon : StarIcon,
    onClick: (e) => onClick(e),
  }

  return (
    <Image {...starProps}/>
  );
});
